import { render, staticRenderFns } from "./PayInvoiceLayout.vue?vue&type=template&id=51b16b54&"
import script from "./PayInvoiceLayout.vue?vue&type=script&lang=js&"
export * from "./PayInvoiceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b16b54')) {
      api.createRecord('51b16b54', component.options)
    } else {
      api.reload('51b16b54', component.options)
    }
    module.hot.accept("./PayInvoiceLayout.vue?vue&type=template&id=51b16b54&", function () {
      api.rerender('51b16b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/PayInvoiceLayout.vue"
export default component.exports